import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import PrimaryButton from 'components/primary-button'
import SecondaryButton from 'components/secondary-button'

import styles from './grid-header.css'

const GridHeader = ({ children, onCancel, onSave }) => (
  <div styleName="grid-header">

    <p styleName="title">{children}</p>

    <div styleName="actions">
      <SecondaryButton label="Cancel" onClick={onCancel} />
      <div styleName="save-button">
        <PrimaryButton label="Save" onClick={onSave} />
      </div>
    </div>
  </div>
)

GridHeader.propTypes = {
  children: PropTypes.any,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
}

export default CSSModules(GridHeader, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-header/grid-header.js
 **/